export type AmountStat = {
  Amount: number;
  Currency: string | null;
  CurrencySymbol: string | null;
};

const isOptionalString = (value: unknown): value is string | null | undefined =>
  value == null || typeof value === 'string';

export const parseAmountStats = (value: unknown): AmountStat[] => {
  try {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    if (!Array.isArray(parsed)) return [];

    return parsed.flatMap((item) => {
      if (!item || typeof item !== 'object') return [];

      const candidate = item as Record<string, unknown>;
      if (
        typeof candidate.Amount !== 'number' ||
        !Number.isFinite(candidate.Amount) ||
        !isOptionalString(candidate.Currency) ||
        !isOptionalString(candidate.CurrencySymbol)
      ) {
        return [];
      }

      return [
        {
          Amount: candidate.Amount,
          Currency: candidate.Currency ?? null,
          CurrencySymbol: candidate.CurrencySymbol ?? null,
        },
      ];
    });
  } catch {
    return [];
  }
};

export const formatAmountStat = (value: AmountStat): string =>
  `${value.CurrencySymbol ?? value.Currency ?? ''}${value.Amount}`;
